module.exports = __webpack_public_path__ + "static/media/festival_2025.58390f41.png";